import fr from 'facet-rest';
import { TextInputLarge } from 'Packages/FacetDesign/Components/TextInput';
import { PasswordInputLarge } from 'Packages/FacetDesign/Components/PasswordInput';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/Text';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';
import { SwitchInput } from 'Packages/FacetDesign/Components/SwitchInput';
import { SSNInputLarge } from 'Packages/FacetDesign/Components/SSNInput';
import { PhoneInputLarge } from 'Packages/FacetDesign/Components/PhoneInput';
import { PercentInputLarge } from 'Packages/FacetDesign/Components/PercentInput';
import { NumberInputLarge } from 'Packages/FacetDesign/Components/NumberInput';
import { CurrencyInputLarge } from 'Packages/FacetDesign/Components/CurrencyInput';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { FDBodyText } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';


export const overrideReadOnly = { ordinal: 200 };

const baseOverrideLite = fr.metaOverride()
  .typeOverride('string', { _component: () => TextInputLarge }, overrideReadOnly); // Needs to support rowsMax/rowsMin/multiple


/** @deprecated -- This is used in MetaResourceRendererLite to only import the necessary components used by the
 marketing app. In basically every other use case in the app you probably want the full facet design override set. * */
export const buildFacetDesignOverrideLite = () => fr.metaOverride({ base: baseOverrideLite })
  .nameOverride('password', { _component: () => PasswordInputLarge }, overrideReadOnly)
  .typeOverride('number', { _component: () => NumberInputLarge }, overrideReadOnly)
  .typeOverride('bool', { _component: () => CheckboxInputLarge }, overrideReadOnly)
  .typeOverride('multipicklist', {
    _customProps: { multiple: true },
  }, overrideReadOnly)
  .override({ hint: 'switch' }, { _component: () => SwitchInput }, overrideReadOnly)
  .override({ hint: 'phoneNumber' }, { _component: () => PhoneInputLarge }, overrideReadOnly)
  .override({ type: 'phone' }, { _component: () => PhoneInputLarge }, overrideReadOnly)
  .override({ hint: 'ssn' }, { _component: () => SSNInputLarge }, overrideReadOnly)
  .override({ hint: 'sensitive' }, { _component: () => PasswordInputLarge }, overrideReadOnly)
  .override({ hint: 'taxid' }, { _component: () => SSNInputLarge }, overrideReadOnly) // What is the difference between taxid and ssn?
  .override({ hint: 'usd' }, { _component: () => CurrencyInputLarge }, overrideReadOnly)
  .override({ hint: 'percent' }, { _component: () => PercentInputLarge }, overrideReadOnly)
  // After all numeric overrides, make sure that any number is replaced with a text input because readonly numbers get special formatting on their values that cause NaN issues
  .override({ type: 'number', readonly: true }, { _component: () => TextInputLarge }, overrideReadOnly)
  .override({ hint: 'body', readonly: true }, { _component: () => BodyTextMedium }, overrideReadOnly)
  .override({ hint: 'body', readonly: true }, { _component: () => BodyTextMedium }, overrideReadOnly)
  .override({ hint: 'richtext', readonly: true }, { _component: () => Richtext }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => Richtext,
    _customProps: {
      Component: FDBodyText,
      color: 'textDisabled',
      size: 'sm',
      ...dataAttrs('disclosure'),
    },
  }, overrideReadOnly);


// TODO: Need FacetDesign input for hint: zipcode
